<template>
  <div class="homepage">
    <myheadBlock></myheadBlock>　
    <div class="hometiebox">
      <div class="hometieboximg">
        <img src="~assets/images/reg/bg1.jpg" alt="" />
      </div>
      <!-- <div class="hometielogo">
        <img src="~assets/images/head/logo3.png" alt="" />
      </div> -->
      <div class="loginbox" v-show="showloginbox">
        <div class="posline">
          <div class="myposline1" @click="handleMousepos1">
            <a href="javascript:void(0)"><span v-show="showqrcode" class="poschoose"> 验证码登录 </span>
              <span v-show="!showqrcode">验证码登录</span></a>
            <!-- <img src="~assets/images/home/poschoose1.jpg" alt="" v-show="showpos2" />
            <img src="~assets/images/home/poschoose2.jpg" alt="" v-show="showpos1" /> -->
          </div>
          <div class="myposline2" @click="handleMousepos2">
            <a href="javascript:void(0)">
              <span v-show="showqrcode">密码登录</span>
              <span v-show="!showqrcode" class="poschoose">密码登录</span></a>
          </div>
        </div>
        <div class="regtextbox">您所在地区仅支持手机号、微信登录</div>　
        <div class="pswloginbox" v-show="!showqrcode">
          <div class="regitem2">
            <div class="reginput1">
              <div class="reginput1icon">
                <img src="~assets/images/reg/iconphone.png" alt="" />
              </div>
              <input type="text" placeholder="请输入手机号" v-model="formData.username" />
            </div>
            <div class="reginput2">
              <div class="reginput1icon">
                <img src="~assets/images/reg/iconpsw.png" alt="" />
              </div>
              <input type="password" placeholder="请输入密码" v-model="formData.password" />
            </div>
            <div class="regtextbox2">
              注册登录即表示您已阅读并同意我们的用户协议和隐私策略
            </div>
            <div class="regbtn" @click="handleloginbtn"
            :class="{ disabled: isButton2Disabled }"
            >
              <a href="javascript:void(0)"> {{ isButton2Disabled ? '登录中...' : '登录' }}</a>
            </div>
          </div>　
          <div class="regtextbox3">
            <div class="forgetpsw" @click="handleforgetpsw">
              <a href="javascript:void(0)">忘记密码</a>
            </div>
            <div class="gotoreg" @click="handlegotoreg">
              <a href="javascript:void(0)">立即注册</a>
            </div>
          </div>
        </div>　
        <div class="codeloginbox" v-show="showqrcode">
          <div class="regitem2">
            <div class="reginput1">
              <div class="reginput1icon">
                <img src="~assets/images/reg/iconphone.png" alt="" />
              </div>
              <input type="text" placeholder="请输入手机号" v-model="formData2.username" />
            </div>
            <div class="reginput2">
              <div class="reginput1icon">
                <img src="~assets/images/reg/iconpsw.png" alt="" />
              </div>
              <input type="password" placeholder="请输入验证码" v-model="formData2.password" />
              <div class="reginput2sendbtn" @click="handlerSendpsw">
                <a href="javascript:void(0)">发送验证码</a>
              </div>
            </div>
            <div class="regtextbox2">
              注册登录即表示您已阅读并同意我们的用户协议和隐私策略
            </div>
            <div class="regbtn" 
            @click="handlelogincodebtn"
            :class="{ disabled: isButton3Disabled }">
              <a href="javascript:void(0)"> {{ isButton3Disabled ? '登录中...' : '登录' }}</a>
            </div>
          </div>　
          <div class="regtextbox3">
            <div class="forgetpsw" @click="handleforgetpsw">
              <a href="javascript:void(0)">忘记密码</a>
            </div>
            <div class="gotoreg" @click="handlegotoreg">
              <a href="javascript:void(0)">立即注册</a>
            </div>
          </div>
        </div>
      </div>　
      <div class="regbox" v-show="showregbox">
        <div class="regtextbox">您所在地区仅支持手机号、微信登录</div>　
        <div class="codeloginbox">
          <div class="regitem2">　
            <div class="reginput1">
              <div class="reginput1icon">
                <img src="~assets/images/reg/iconphone.png" alt="" />
              </div>
              <input type="text" placeholder="请输入手机号" v-model="formData3.username" />
            </div>
            <div class="reginput2">
              <div class="reginput1icon">
                <img src="~assets/images/reg/icocode.png" alt="" />
              </div>
              <input type="password" placeholder="请输入验证码" v-model="formData3.code" />
              <div class="reginput2sendbtn" @click="handlerSendpsw">
                <a href="javascript:void(0)">发送验证码</a>
              </div>　
            </div>　
            <div class="reginput3">
              <div class="reginput1icon">
                <img src="~assets/images/reg/iconpsw.png" alt="" />
              </div>
              <input type="password" placeholder="请输入密码" v-model="formData3.password" />
            </div>　
            <div class="reginput4">
              <div class="reginput1icon">
                <img src="~assets/images/reg/iconpsw.png" alt="" />
              </div>
              <input type="password" placeholder="请再次输入密码" v-model="formData3.password2" />
            </div>
　
            <div class="regtextbox2">
              注册登录即表示您已阅读并同意我们的用户协议和隐私策略
            </div>
            <div class="regbtn" @click="handleregbtn" :class="{ disabled: isButton1Disabled }">
              <a href="javascript:void(0)"> {{ isButton1Disabled ? '注册中...' : '注册' }}</a>
            </div>　
            <div class="regtextbox3">
              <div class="forgetpsw" @click="handlebacklogin">
                <a href="javascript:void(0)">返回登陆</a>
              </div>　
            </div>
          </div>
        </div>
      </div>
    </div>　
    <footerBlock></footerBlock>
  </div>
</template>
//
<script>
import footerBlock from "./../components/block/footer";
import myheadBlock from "./../components/block/myhead";
import axios from "axios"; // 导入 Axios
export default {
  name: "regPage",
  data() {
    return {
      msg: "",
      showloginbox: true,
      showqrcode: true,
      showregbox: false,
      response: null, // 存储服务器返回的数据
      error: null, // 存储请求错误信息
      formData: {
        username: "", // 用户名（手机号或邮箱）
        password: "", //  密码
      },
      formData2: {
        username: "", // 用户名（手机号或邮箱）
        password: "", // 验证码
      },
      formData3: {
        username: "", // 用户名（手机号或邮箱）
        password: "", // 密码
        password2: "", // 密码
        code: "", // 验证码
      },
      isButton1Disabled: false,
      isButton2Disabled: false,
      isButton3Disabled: false,
     
    };
  },
  components: {
    footerBlock,
    myheadBlock,
  },
  computed: {
    // swiper() {
    //   return this.$refs.mySwiper.swiper;
    // }
  },
  methods: {
    gotoHomePage: function () {
      console.log("gotoHomePage");
      this.$router.push({
        name: "Index",
      });
    },
    gotoMyPage: function () {
      this.$router.push({
        name: "mypage",
      });
    },
    gotoSetPage: function () {
      this.$router.push({
        name: "Setpage",
      });
    },
    gotoRankPage: function () {
      this.$router.push({
        name: "Rankpage",
      });
    },　
    handleMousepos1: function () {
      console.log("handleMousepos1");
      this.showqrcode = true;
    },
    handleMousepos2: function () {
      console.log("handleMousepos2");
      this.showqrcode = false;
    },　
    handleMouseposbtn: function () {
      console.log("handleMouseRtype3");
      this.showposbtn = true;
    },
    handleMouseoutPosbtn: function () {
      console.log("handleMouseoutRtype3");
      this.showposbtn = false;
    },
    handleloginbtn: function () {
      console.log("handleloginbtn");
      this.sendloginPostRequest();
    },
    async sendloginPostRequest() {
      try {
        // 清空之前的响应和错误信息
        this.response = null;
        this.error = null;
        // 验证用户输入
        if (!this.formData.username || !this.formData.password) {
          this.error = "请输入用户名和密码";
          return;
        }
        if (this.isButton2Disabled) return;　
        // 禁用按钮
        this.isButton2Disabled = true;　
        // 配置 POST 请求的 URL 和数据
        const url = " https://ttserver.aizhuotice.online/api/v1/local/login";
        const postData = {
          name: "phoneNumber",
          password: "1234",
        };　
        // 发起 POST 请求
        const response = await axios.post(url, this.formData);　
        // 处理成功响应
        this.response = response.data; // 将返回的数据存储到组件状态　
        if (this.response.code == 200) {
         
          localStorage.setItem('token', this.response.data.token);
           alert("登录成功");
          this.gotoHomePage();
        }else{
          alert(this.response.msg);
        }
      } catch (err) {
        // 处理请求错误
        if (err.response) {
          // 服务器返回了错误响应（例如 4xx 或 5xx）
          this.error = `服务器错误: ${err.response.status} - ${err.response.statusText}`;
        } else if (err.request) {
          // 请求已发出，但没有收到响应
          this.error = "未收到服务器响应";
        } else {
          // 其他错误
          this.error = `请求失败: ${err.message}`;
        }
      } finally {
        // 无论成功或失败，都重新启用按钮
        this.isButton2Disabled = false;
      }
    },　
    handlelogincodebtn: function () {
      console.log("handlelogincodebtn");
      this.sendlogincodePostRequest();
    },
    async sendlogincodePostRequest() {//验证码
      try {
        // 清空之前的响应和错误信息
        this.response = null;
        this.error = null;
        // 验证用户输入
        if (!this.formData2.username || !this.formData2.password) {
          this.error = "请输入用户名和密码";
          return;
        }
        if (this.isButton3Disabled) return;　
        // 禁用按钮
        this.isButton3Disabled = true;　
        // 配置 POST 请求的 URL 和数据
        const url = " https://ttserver.aizhuotice.online/api/v1/local/login";
        // const postData = {
        //   name: "phoneNumber",
        //   password: "1234",
        // };　
        // 发起 POST 请求
        const response = await axios.post(url, this.formData2);　
        // 处理成功响应
        this.response = response.data; // 将返回的数据存储到组件状态
        if (this.response.code == 200) {
          localStorage.setItem('token', this.response.data.token);　
          alert("登录成功");
          gotoHomePage();
        }
      } catch (err) {
        // 处理请求错误
        if (err.response) {
          // 服务器返回了错误响应（例如 4xx 或 5xx）
          this.error = `服务器错误: ${err.response.status} - ${err.response.statusText}`;
        } else if (err.request) {
          // 请求已发出，但没有收到响应
          this.error = "未收到服务器响应";
        } else {
          // 其他错误
          this.error = `请求失败: ${err.message}`;
        }
      }
    },
　
    handleregbtn: function () {
      console.log("handleregbtn");
      this.sendRegPostRequest();
    },
    async sendRegPostRequest() {
      try {
        if (this.isButton1Disabled) return;　
        // 禁用按钮
        this.isButton1Disabled = true;　
        // 清空之前的响应和错误信息
        this.response = null;
        this.error = null;
        // 验证用户输入
        if (!this.formData3.username || !this.formData3.password || !this.formData3.password2 || !this.formData3.code) {
          this.error = "请输入用户名和密码";
          return;
        }
        if (this.formData3.password !== this.formData3.password2) {
          this.error = "两次密码不一致";
          return;
        }　
        // 配置 POST 请求的 URL 和数据
        const url = "https://ttserver.aizhuotice.online/api/v1/local/register";
        // const postData = {
        //   phoneNumber: "12345",
        //   password: "1234",
        // };　
        // 发起 POST 请求
        const response = await axios.post(url, this.formData3);　
        // 处理成功响应
        this.response = response.data; // 将返回的数据存储到组件状态
        console.log(this.response);
        if (this.response.code == 200) {
          alert("注册成功");
          this.showloginbox = true;
           this.showregbox = false;
           this.showqrcode = false;
        }
      } catch (err) {
        // 处理请求错误
        if (err.response) {
          // 服务器返回了错误响应（例如 4xx 或 5xx）
          this.error = `服务器错误: ${err.response.status} - ${err.response.statusText}`;
        } else if (err.request) {
          // 请求已发出，但没有收到响应
          this.error = "未收到服务器响应";
        } else {
          // 其他错误
          this.error = `请求失败: ${err.message}`;
        }
      } finally {
        // 无论成功或失败，都重新启用按钮
        this.isButton1Disabled = false;
      }
    },
    handleforgetpsw: function () {
      console.log("handleforgetpsw");
    },
    handlegotoreg: function () {
      console.log("handlegotoreg");
      this.showloginbox = false;
      this.showregbox = true;
    },
    handlerSendpsw: function () {
      console.log("handlerSendpsw");
    },　
    handlebacklogin: function () {
      console.log("handlebacklogin");
      this.showloginbox = true;
      this.showregbox = false;
    },
  },
  mounted() { },
  created() { },
};
</script>



<style scoped>
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}



.hometiebox {
  width: 100vw;
  height: 56.7vw;
  position: relative;
}

.hometieboximg {
  width: 100%;
  height: 100%;
}

.hometieboximg img {
  width: 100%;
  height: 100%;
}

.hometiebtnimg {
  position: absolute;
  top: 37.5vw;
  left: 38vw;
  width: 25.5vw;
  height: 5.5vw;
}

.hometiebtnimg img {
  width: 100%;
  height: 100%;
}

.hometiebox2 {
  width: 100vw;
  height: 56.7vw;
  position: relative;
}

.hometielogo {
  position: absolute;
  width: 10vw;
  height: 10vw;
  top: 2vw;
  left: 45vw;
}

.hometielogo img {
  width: 100%;
  height: auto;
}

.loginbox {
  position: absolute;
  width: 84vw;
  height: 40vw;
  top: 9vw;
  left: 10vw;
  background-color: rgba(0, 0, 0, 0.8);
  border-radius: 20px;
  margin-left: 0vw;
  /* padding-left: 10vw; */
}

.posline {
  position: absolute;
  top: 5vw;
  left: 11vw;
  width: 50vw;
  height: 3vw;
}

.myposline1 {
  position: absolute;
  top: 0vw;
  left: 16vw;
  width: 15vw;
  height: 3vw;
}

.myposline2 {
  position: absolute;
  top: 0vw;
  left: 32vw;
  width: 10vw;
  height: 3vw;
}

.myposline1 img,
.myposline2 img {
  width: 100%;
  height: auto;
}

.posline span {
  font-size: 30px;
  color: #fff;
  font-weight: bold;
}

.posline .poschoose {
  color: #a82024;
  border-bottom: 4px solid #a82024;
}

.regtextbox {
  position: absolute;
  top: 10vw;
  left: 27vw;
  width: 50vw;
  height: 3vw;
  font-size: 18px;
  color: #aaa;
  font-weight: bold;
}

.regitem2 {
  position: absolute;
  top: 13vw;
  left: 15vw;
  width: 34vw;
  height: 3vw;
}

.reginput1 {
  position: absolute;
  top: 0vw;
  left: 0vw;
  width: 34vw;
  height: 3vw;
  display: flex;
  border: 1px solid #fff;
  border-radius: 6px;
  background-color: #fff;
}

.reginput2 {
  position: absolute;
  top: 5vw;
  left: 0vw;
  width: 34vw;
  height: 3vw;
  display: flex;
  border: 1px solid #fff;
  border-radius: 6px;
  background-color: #fff;
}

.regitem2 input {
  width: 100%;
  height: 100%;
  border: none;
  font-size: 22px;
  font-weight: bold;
  color: #000;
  display: flex;
  position: relative;
  border-radius: 6px;
}

.regitem2 input::placeholder {
  color: #aaa;
  font-size: 18px;
  font-weight: bold;
}

.reginput1icon {
  display: flex;
}

.regtextbox2 {
  position: absolute;
  top: 10vw;
  left: 0vw;
  width: 50vw;
  height: 3vw;
  font-size: 18px;
  color: #aaa;
  font-weight: bold;
}

.regbtn {
  position: absolute;
  top: 16vw;
  left: 0vw;
  width: 34vw;
  height: 4.5vw;
  font-size: 26px;
  font-weight: bold;
  color: #fff;
  background-color: #a82024;
  border-radius: 6px;
  text-align: center;
  line-height: 4.5vw;
}

.regbtn a {
  color: #fff;
}

.regtextbox3 {
  position: absolute;
  top: 35vw;
  left: 15vw;
  width: 34vw;
  height: 4.5vw;
  font-size: 18px;
  color: #a82024;
  font-weight: bold;
}

.gotoreg {
  position: absolute;
  top: 0vw;
  right: 0vw;
}

.regtextbox3 a {
  color: #a82024;
}

.pswloginbox,
.codeloginbox {
  /* display: none; */
  left: 10vw;
  position: relative;
  ;
}

.codeloginbox .reginput2 {
  width: 18vw;
}

.reginput2sendbtn {
  position: absolute;
  top: 0vw;
  left: 19vw;
  width: 15vw;
  height: 3.5vw;
  font-size: 22px;
  font-weight: bold;
  color: #fff;
  background-color: #a82024;
  border-radius: 6px;
  text-align: center;
  line-height: 3.5vw;
}

.reginput2sendbtn a {
  color: #fff;
}

.codeloginbox .reginput2 {
  height: 3.4vw;
}

.regbox {
  position: absolute;
  width: 84vw;
  height: 45vw;
  top: 9vw;
  left: 10vw;
  background-color: rgba(0, 0, 0, 0.8);
  border-radius: 20px;
}

.regbox .regtextbox {
  top: 5vw;
  left: 25vw;
}

.regbox .codeloginbox {
  position: absolute;
  top: 0vw;
  left: 10vw;
}

.regbox .codeloginbox .regitem2 {
  top: 8vw;
}


.reginput3 {
  position: absolute;
  top: 10vw;
  left: 0vw;
  width: 34vw;
  height: 3vw;
  display: flex;
  border: 1px solid #fff;
  border-radius: 6px;
  background-color: #fff;
}

.regitem3 input {
  width: 100%;
  height: 100%;
  border: none;
  font-size: 22px;
  font-weight: bold;
  color: #000;
  display: flex;
  position: relative;
  border-radius: 6px;
}

.regitem3 input::placeholder {
  color: #aaa;
  font-size: 18px;
  font-weight: bold;
}


.reginput4 {
  position: absolute;
  top: 15vw;
  left: 0vw;
  width: 34vw;
  height: 3vw;
  display: flex;
  border: 1px solid #fff;
  border-radius: 6px;
  background-color: #fff;
}

.regitem4 input {
  width: 100%;
  height: 100%;
  border: none;
  font-size: 22px;
  font-weight: bold;
  color: #000;
  display: flex;
  position: relative;
  border-radius: 6px;
}

.regitem4 input::placeholder {
  color: #aaa;
  font-size: 18px;
  font-weight: bold;
}

.regbox .regtextbox2 {
  top: 20vw;
}

.regbox .regbtn {
  top: 25vw;
}



.regbox .regtextbox3 {
  position: absolute;
  top: 31vw;
  left: 15vw;
  width: 34vw;
  height: 4.5vw;
  font-size: 18px;
  color: #a82024;
  font-weight: bold;
}

.regbox .gotoreg {
  position: absolute;
  top: 0vw;
  right: 0vw;
}

.regbox .regtextbox3 a {
  color: #a82024;
}

.regbtn.disabled {
  background-color: #ccc; /* 灰色背景表示禁用 */
  cursor: not-allowed; /* 鼠标悬停时显示“禁止”光标 */
  pointer-events: none; /* 禁用点击事件 */
}
.regbtn.disabled a {
  color: #666; /* 文字颜色变淡 */
}
</style>



// WEBPACK FOOTER //
// src/components/Reg.vue